import Glide from '@glidejs/glide'

const sliders = document.querySelectorAll('.glide')
const conf = {
	type: 'carousel',
	gap: 0,
	autoplay: 2500,
	hoverpause: false,
	keyboard: false,
	peek: 0,
	breakpoints: {
		1200: {
			perView: 1,
			peek: 0	
		},
		900: {
			perView: 1,
			peek: 0
		},
		600: {
			perview: 1,
			peek: 0,
			gap: 0
		}
	},
}

export const addSliders = () => {
	const sliders = document.querySelectorAll('.glide');
	if (sliders.length > 0) {
		sliders.forEach(item => {
			new Glide(item, conf).mount();
		})
	}
}

addSliders();